module.exports = __webpack_public_path__ + "static/media/IMG_4373.bb954fe2.jpg";